var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWatercourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 589.157 503.239"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 28",
    fill: "#6f9d20",
    d: "M0 0h503.239v503.239H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 129",
    d: "M104.332 35.186a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 131",
    d: "M168.772 121.105a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 132",
    d: "M239.348 32.117a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 133",
    d: "M392.774 29.049a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M328.335 124.173a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 135",
    d: "M104.332 213.161a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M257.759 210.092a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M417.322 213.161a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M438.802 124.173a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 140",
    d: "M168.772 299.079a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 141",
    d: "M328.335 302.148a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 142",
    d: "M104.332 391.135a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 143",
    d: "M257.759 388.067a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 144",
    d: "M417.322 391.135a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 145",
    d: "M438.802 302.148a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M61.373 473.985a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 147",
    d: "M239.348 480.123a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 148",
    d: "M392.774 477.054a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    fill: "#85d0e6",
    d: "M497.101 0h92.056v503.239h-92.056z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 223",
    d: "M527.34 86.616c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 224",
    d: "M564.162 151.055c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 225",
    d: "M521.202 206.29c-1.031-.952-1.558-2.937-1.585-4.964a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 226",
    d: "M564.162 264.591c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 227",
    d: "M521.202 335.167c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 228",
    d: "M558.025 405.743c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 229",
    d: "M521.202 464.045c-1.031-.951-1.558-2.936-1.585-4.963a21.974 21.974 0 01.926-6.042c.948-3.431 2.282-6.608 3.317-9.987a27.153 27.153 0 001.393-10.587c-.566-5.097-3.503-8.98-2.95-14.31",
    fill: "none",
    stroke: "#06637e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 230",
    d: "M33.756 118.036a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 231",
    d: "M33.756 296.011a4.04 4.04 0 012.861-2.18 8.117 8.117 0 013.694.182c2.129.523 4.134 1.46 6.237 2.075a10.094 10.094 0 006.455.093c3.017-1.182 5.13-4.568 8.37-4.671",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 205",
    fill: "#fdc135",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M146.52 461.815V32.221h211.728v429.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M147.02 461.315V32.721h210.728v428.594z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 233",
    fill: "#c7c7c7",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M167.613 440.721V53.314h169.541v387.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M168.113 440.221V53.814h168.541v386.407z"
  })))));
}

export default __webpack_public_path__ + "0d9b32d307982d5c7462135d4f6358d7.svg";
export { SvgIconWatercourse as ReactComponent };